import { useAppDispatch, useAppSelector } from '@/hooks'
import { useEffect } from 'react'
import { programsNewCollection } from '@/reducers/programsNew'
import { thermostatsCollection } from '@/reducers/thermostats'

// used for syncing global redux cache side effects
// since redux advises against adding side effects to reducers,
// track it globally instead
export default function useGlobalReduxCacheInvalidation() {
  const dispatch = useAppDispatch()
  const vehicles = useAppSelector((state) => state.vehicles.vehicles)
  const { data: thermostats } = thermostatsCollection.useFetch()
  const thermostatIds = thermostats
    .map((thermostat) => thermostat.id)
    .toSorted()
    .join(',')
  const vehicleIds = vehicles
    ?.map((vehicle) => vehicle.id)
    .toSorted()
    .join(',')
  useEffect(() => {
    dispatch(programsNewCollection.actions.invalidate())
  }, [vehicleIds, thermostatIds])
}
